import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const useContacts = (page, filters) => {
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState({});
  const [totalPages, setTotalPages] = useState(1);

  const fetchContacts = useCallback(async () => {
    try {
      const params = {
        page,
        user_name: filters.name,
        email: filters.email,
        createdAtFrom: filters.dateFrom,
        createdAtTo: filters.dateTo,
      };
      const { data } = await axios.get('/api/v1/contact/get-contact', { params });
      setContacts(data.contacts);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    }
  }, [page, filters]);

  useEffect(() => {
    fetchContacts();
  }, [fetchContacts]);

  const handleSelect = (contact) => {
    const id = contact.id;
    setSelectedContacts((prev) => ({
      ...prev,
      [id]: prev[id] ? undefined : contact,
    }));
  };

  const handleDownload = () => {
    const selected = Object.values(selectedContacts).filter(Boolean);
    if (!selected.length) return;

    const csvContent = [
      ['Name', 'Email', 'Date', 'Message', 'UTM'],
      ...selected.map((c) => [
        c.user_name,
        c.email,
        c.createdAt,
        c.message,
        c.utm_source || c.utm_medium || c.utm_campaignid || c.adgroup_id
          ? `Source: ${c.utm_source || ''}, Medium: ${c.utm_medium || ''}, Campaign ID: ${c.utm_campaignid || ''}, Adgroup ID: ${c.adgroup_id || ''}`.replace(/, ,/g, '').replace(/^, |, $/g, ' ')
          : 'N/A'
      ]),
    ]
      .map((e) => e.join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'selected_contacts.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return {
    contacts,
    totalPages,
    fetchContacts,
    selectedContacts,
    setSelectedContacts,
    handleSelect,
    handleDownload,
  };
};

export default useContacts;
